module.exports = __webpack_public_path__ + "static/media/4.8449e96d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/novopolotsk/4.jpg
// module id = 246
// module chunks = 0